// ==================== CUSTOM BUTTON COMPONENT ====================

import React from 'react';
import { Button } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

const CustomButton = ({
  children,
  variant = 'contained',
  gradient = 'primary',
  glow = false,
  sx = {},
  ...props
}) => {
  const { colors } = useTheme();

  const getButtonStyles = () => {
    if (variant === 'gradient') {
      return {
        background: colors[gradient]?.gradient || colors.primary.gradient,
        color: colors[gradient]?.contrastText || '#ffffff',
        '&:hover': {
          background: `linear-gradient(135deg, ${colors[gradient]?.dark} 0%, ${colors[gradient]?.dark} 100%)`,
          boxShadow: glow ? `0 0 20px ${colors.shadows[gradient]}` : undefined,
        },
      };
    }
    return {};
  };

  return (
    <Button
      variant={variant === 'gradient' ? 'contained' : variant}
      sx={{
        ...getButtonStyles(),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
